import { Col, Divider, Row, Typography } from "antd";
import React from "react";
import { formatDateInMMDDYYYY } from "../../../helpers/date";
import DeleteFormulaItem from "../formula-items/DeleteFormulaItem";
import FormulaSwitch from "../formula-items/FormulaSwitch";
import EditIcon from "./../../../graphics/svgs/EditIcon.svg";
import "./dashboardcard.css";
const FormulaItemCard: React.FC<IFormulaMobileCard> = ({
  formula,
  handleUpdateFormulaStatus,
  deleteFormula,
  handleEditFormula,
}) => {
  return (
    <>
      <div className="dashboard-item-card">
        <Row className="dashboard-card-single-item-container">
          <Col className="checkbox-dashboard-item" span={24}>
            <FormulaSwitch
              _id={formula._id}
              handleUpdateFormulaStatus={handleUpdateFormulaStatus}
              isActive={formula.isActive}
            />
            <img
              onClick={(e) => handleEditFormula(formula)}
              src={EditIcon}
              style={{ width: "25px", cursor: "pointer" }}
            />
            <DeleteFormulaItem
              _id={formula._id}
              deleteFormula={deleteFormula}
            />
          </Col>
          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Active ingredients
            </Typography>
            <Typography className="users-table-generic-label">
              {formula.activeIngredients}
            </Typography>

            <Divider />
          </Col>

          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Cream base
            </Typography>

            <Typography className="users-table-generic-label">
              {formula.activeIngredients}
            </Typography>
            <Divider />
          </Col>

          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Number of times used
            </Typography>

            <Typography className="users-table-generic-label">
              {" "}
              {formula.orderCount}
            </Typography>
            <Divider />
          </Col>

          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Last used
            </Typography>

            <Typography className="users-table-generic-label">
              {formatDateInMMDDYYYY(new Date(formula.createdAt))}
            </Typography>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default FormulaItemCard;
